var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cursor-pointer font-bold",on:{"click":function($event){return _vm.params.colDef.CellRendererParams.goToGradebook(_vm.params.data)}}},[_vm._v("Result")])
}
var staticRenderFns = []

export { render, staticRenderFns }